import apiService from '@/services/api.service'

import CompanyTool from '../tools/CompanyTool'

async function setLocalStorage() {
    let spaceConfig = null
    if (window.location.hostname != 'localhost' && window.location.hostname != 'demo.savlog.net') {
        // Check if there is an alias with this domain name
        spaceConfig = await apiService.postProd('get_alias', {
            alias_domain_name: window.location.hostname
        })
        if (spaceConfig.data.posts.post.length <= 0) {
            console.error('No alias found');
        }
    // If url == '/{keyname}'
    } else {
        spaceConfig = await apiService.postProd('get_alias', {
            url_keyname: CompanyTool.keyname
        })
    }

    // Save config file in local storage
    if (spaceConfig && spaceConfig.data.posts.post.length > 0) {
        spaceConfig = spaceConfig.data.posts.post[0]
        const lastConf = localStorage.getItem('space-conf')
        if (!lastConf || (lastConf && JSON.parse(lastConf).url_keyname != spaceConfig.url_keyname)) {
            // location.reload()
        }
        localStorage.setItem('space-conf', JSON.stringify(spaceConfig))
    } else {
        localStorage.removeItem('space-conf')
    }
}
var SpaceTool = {
    setLocalStorage,
}

export default SpaceTool



// WEBPACK FOOTER //
// ./src/tools/SpaceTool.js